import { createApiSlice } from 'app/createApiSlice'
import { API_PROJECTS_SELECTION } from 'utils/apiList'

export const projectsSelectionApiSlice = createApiSlice.injectEndpoints({
  reducerPath: 'projectsSelection/api',
  endpoints(builder) {
    return {
      fetchProjectsSelection: builder.query({
        query() {
          return {
            url: `/${API_PROJECTS_SELECTION}`,
          }
        },
      }),
    }
  },
})

export const {
  useFetchProjectsSelectionQuery,
  useLazyFetchProjectsSelectionQuery,
} = projectsSelectionApiSlice
